<template>
  <nav v-if="showNav">
    <v-app-bar
    tile
    dark
    :color="config.primary"
    fixed
    app
    >
      <v-btn
        icon
        v-if="$route.name != 'create'"
        @click="toggleDrawer()"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-btn
        class="mr-3"
        v-if="$route.name == 'create'"
        @click="leaveCreator()"
        outlined
      >
        <v-icon left>mdi-arrow-left</v-icon>
        Leave creator
      </v-btn>
      <v-toolbar-title class="d-none d-sm-flex">
        <span :class="config.light_text_class">Chip Customizer</span>
      </v-toolbar-title>
      <v-form
        @submit.prevent="search"
      >
        <v-text-field
        v-if="$route.name != 'create'"
        placeholder="Search For Chips..."
        class="ml-3"
        hide-details
        prepend-icon="mdi-magnify"
        single-line
        v-model="searchField"
        >
        </v-text-field>
      </v-form>
      <div class="d-none d-md-flex ml-3" v-if="loggedIn">
        <v-btn v-if="$route.name != 'create'" @click="navigateTo('created')" text class="" :color="config.light_text_class">
          <span>My Chips</span>
          <v-icon right>mdi-account</v-icon>
        </v-btn>
      </div>
      <div class="d-none d-md-flex ml-3" v-if="loggedIn">
        <v-btn v-if="$route.name != 'create'" @click="navigateTo('create')" text class="" :color="config.light_text_class">
          <span>Create a Chip</span>
          <v-icon right>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <div v-if="this.loggedIn">
        <v-btn href="https://chipcustomizer.com/products/" target="_blank" text class="" :color="config.light_text_class">
          <span>Need more labels?</span>
        </v-btn>
      </div>
      <div v-if="!this.loggedIn">
        <v-btn @click="navigateTo('login')" text class="" :color="config.light_text_class">
          <span>Login</span>
          <v-icon right>mdi-account-arrow-right</v-icon>
        </v-btn>
      </div>
      <div class="mr-3 ml-3">
        <v-btn v-if="$route.name != 'create'" @click="navigateTo('home')" icon class="" :color="config.light_text_class">
          <v-icon>mdi-home</v-icon>
        </v-btn>
      </div>
    </v-app-bar>
    <v-navigation-drawer
      width="300px"
      :dark="config.dark_background"
      v-model="drawer"
      fixed
      app
      disable-resize-watcher
      temporary
    >
      <v-list-item v-if="this.loggedIn">
        <v-list-item-avatar>
          <v-icon>mdi-account-check</v-icon>
        </v-list-item-avatar>

        <v-list-item-content v-if="this.loggedIn">
          <v-list-item-title class="title">{{this.getUser.name}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!this.loggedIn">
        <v-icon>mdi-account</v-icon>
        <v-list-item-content>
          <v-list-item-title class="ml-5">Click <a @click="navigateTo('login')">here</a> to log in</v-list-item-title>
        </v-list-item-content>
        <v-btn
        icon
        @click="drawer = !drawer"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list>

        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          @click="clickItem(item)"
          :disabled="!item.active && !loggedIn"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          class="mt-5"
          v-if="getUser.admin"
          link
          @click="clickItem({action: 'admin', active: false})"
        >
          <v-list-item-icon>
            <v-icon>mdi-head-minus</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Admin Panel</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>
    <v-dialog v-model="dialog" width="500px">
      <modal>
        <template v-slot:title>
          <v-card-title class="text-break">
            Are you sure you want to leave?
          </v-card-title>
          <v-card-text class="text-break">
            If you leave, any unsaved changed will be lost.
          </v-card-text>
        </template>
        <template v-slot:actions>
          <v-col cols="12" sm="6">
            <v-btn elevation="0" @click="navigateTo('created')" :color="config.primary" block>
              Leave
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6">
            <v-btn elevation="0" @click="dialog = !dialog" :color="config.confirm" block>
              Back to creator
            </v-btn>
          </v-col>
        </template>
      </modal>
    </v-dialog>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import config from'@/config/config'
import Modal from '@/components/Modal.vue'

export default {
  name: 'navbar',
  components: {
    Modal
  },
  data() {
    return {
      drawer: false,
      items: [
      { icon: 'mdi-home', title: 'Home', action: 'home', active: true },
      { icon: 'mdi-circle-edit-outline', title: 'Create', action: 'create', active: false },
      { icon: 'mdi-account', title: 'My Chips', action: 'created', active: false },
      { icon: 'mdi-basket', title: 'Browse', action: 'browse', active: true },
      { icon: 'mdi-heart', title: 'Favorites', action: 'library', active: false },
      { icon: 'mdi-cog', title: 'Settings', action: 'settings', active: false },
      { icon: 'mdi-exit-to-app', title: 'Log Out', action: 'logout', active: false }
      ],
      searchField: '',
      config,
      showNav: true,
      dialog: false
    }
  },
  methods: {
    async leaveCreator () {
      if (this.$route.name == 'create') {
        this.dialog = true
      }
    },
    async toggleDrawer () {
      this.drawer = !this.drawer
    },
    clickItem (item) {
      this.drawer = !this.drawer
      if (item.action != 'logout') {
        this.$router.push({name: item.action})
      } else {
        this.logOut()
      }
    },
    navigateTo (name) {
      this.dialog = false
      this.$router.push({name})
    },
    logOut () {
      this.$store.dispatch('logout')
      this.$router.push({
        name: 'home'
      })
    },
    search () {
      try {
        this.$store.dispatch('changeSearch', this.searchField)
        if (this.$route.name != 'browse') {
          this.$router.push({ name: 'browse' })
        }
      } catch (err) {
        throw err
      }
    },
    syncSearch () {
      try {
        this.searchField = this.getSearchInfo
      } catch (err) {
        throw err
      }
    },
  },
  computed: {
    ...mapGetters({
      loggedIn: 'loggedIn',
      getSearchInfo: 'getSearchInfo',
      getUser: 'getUser'
    })
  },
  watch: {
    searchField: function () {
      if (this.$route.name == 'browse' && this.searchField == '') {
        this.$store.dispatch('changeSearch', this.searchField)
      }
    }
  },
  mounted() {
    this.syncSearch()
    if (this.$route.name == 'changepassword') {
      this.showNav = false
    } else {
      this.showNav = true
    }
  }
}
</script>

<style scoped>

</style>